<template>
    <div>
        <div class="gray_line">
            <div class="gray_inner">
                <div class="item" :class="tab === 1 ? 'active' : ''"><a href="/competition/list_experts_competition">Требуется оценка</a></div>
                <div class="item" :class="tab === 2 ? 'active' : ''" @click="tab = 2"><a>Мои оценки</a></div>
            </div>
        </div>
        <div class="request_content">
            <template v-if="!isLoading">
                <div class="header_title">Мои оценки</div>

                <div class="filters_block_wrapper">
                    <div class="switchers__wrapper">
                        <div class="switch__wrapper">
                            <Switch @change="searchPis" v-model:checked="filterFavorit"></Switch>
                            <span @click="filterFavorit = !filterFavorit">Фавориты</span></div>
                    </div>
                    <div class="search_field_wrapper">
                        <div class="control">
                            <input @input="searchPis" name="search_textfield" class="input search_textfield"
                                   type="text"
                                   placeholder="Найти проект" v-model="search"/>
                        </div>
                        <div class="control">
                            <input value="Поиск" type="submit" class="button search_button is-info"
                                   @click="searchPis">
                        </div>
                    </div>
                </div>


                <div class="header_title">{{ competition.name }}</div>


            </template>
            <Spin v-else></Spin>
						<div class="main_table">
                <Table
                        :columns="columns"
                        :data-source="items"
                        :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : '') + (record.favorite ? ' faborite_row' : '')"
                >
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.key === 'project_name'">
                            <template v-if="record.favorite">
																<div class="project_name__wrapper">
                                    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.7784 8.29378L16.6203 12.7267L18.0632 19.2004C18.1196 19.4561 18.0125 19.7198 17.7899 19.8735C17.5682 20.0264 17.2723 20.0425 17.0337 19.912L11 16.6144L4.97376 19.912C4.73516 20.0425 4.43925 20.0264 4.21663 19.8735C3.99494 19.7198 3.88785 19.4561 3.94422 19.2004L5.3871 12.7267L0.221564 8.29378C0.0233547 8.11768 -0.0499151 7.84861 0.0346285 7.60279C0.118234 7.35697 0.344633 7.18085 0.613275 7.14957L7.52711 6.44963L10.3631 0.394227C10.4749 0.154652 10.7248 0 11 0C11.2752 0 11.5251 0.154647 11.6369 0.394227L14.4729 6.44071L21.3867 7.14064C21.6554 7.17193 21.8818 7.34803 21.9654 7.59387C22.0499 7.8388 21.9766 8.10876 21.7784 8.28486L21.7784 8.29378Z" fill="url(#paint0_linear_1905_4472)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_1905_4472" x1="0" y1="0" x2="22.7793" y2="0.930898" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.0001" stop-color="#F7C100" />
                                                <stop offset="1" stop-color="#F69400" />
                                            </linearGradient>
                                        </defs>
                                    </svg>{{ record.project_name }}
																</div>
                            </template>
                        </template>
                    </template>
                </Table>
						</div>

        </div>
    </div>
</template>

<script setup>
import {ref, computed} from 'vue';
import axios from "axios";
import {Spin, Table, Switch } from "ant-design-vue";

let tab = ref(2);
let isLoading = ref(false);
let competition = ref({});
let scores = ref([]);
let filterFavorit = ref(false);
let filteredScores = ref([]);
let search = ref('');

const columns = ref([
  {
    title: 'Проект',
    dataIndex: 'project_name',
    key: 'project_name',
  },
  {
    title: 'Ваша оценка',
    dataIndex: 'score',
    key: 'score',
  }
]);

async function getData() {
  isLoading.value = true;
  await getCompetition();
  await getScores();

  isLoading.value = false;
}

getData();

async function getCompetition() {
  const response = await axios.get('/api/competitions/' + window.competitionId);
  competition.value = response.data;
}

async function getScores() {
  const response = await axios.post('/get_my_scores_by_competition', null, {
    params: {
      competitionId: window.competitionId
    }
  })
  scores.value = response.data;
}
async function searchPis() {
  filteredScores.value = scores.value;

  if (search.value.length > 0) {
    filteredScores.value = filteredScores.value.filter(object => {
      return object?.project_name?.toLowerCase().includes(search.value.toLowerCase());
    });
  }

  if (filterFavorit.value) {
    filteredScores.value = filteredScores.value.filter(object => {
      return object.favorite === true;
    });
  }

}

const items = computed(() => {
  if (search.value.length > 0 || filterFavorit.value) {
    return filteredScores.value;
  } else {
    return scores.value;
  }
})

</script>

<style lang="scss" scoped>
.filters_block_wrapper {
	display: flex;
	justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 20px;
}
.header_title {
  margin-bottom: 10px;
}

.main_table:deep {
  tr.table-striped td {
    background-color: #fafafa;
  }
  .ant-table-thead .ant-table-cell {
    background-color: #fff;
    font-weight: 300;
    font-size: 14px;
    color: rgba(29, 35, 45, 0.5);
  }
  .ant-table-tbody .ant-table-cell {
    font-size: 16px;
    line-height: 280%;
    color: #1d232d;
		.project_name__wrapper {
			display: flex;
			align-items: center;

      svg {
        margin-right: 10px;
      }
		}
  }
	.faborite_row {
    font-weight: 600;
    font-size: 20px;
    line-height: 280%;
    color: #1d232d;
	}
}

@media (max-width: 1000px) {
	.filters_block_wrapper {
		display: block;
	}
	.search_field_wrapper {
    margin-top: 20px;
	}
	.header_title {
    font-size: 21px;
	}
}

</style>